var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-alert',{attrs:{"show":_vm.dismissCountDown,"dismissible":"","variant":_vm.tipo},on:{"dismissed":function($event){_vm.dismissCountDown=0},"dismiss-count-down":_vm.countDownChanged}},[_vm._v(_vm._s(_vm.mensaje))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }